/* Lauren Boutique: shipping protection ($3,95), standaard aan in de cart drawer. 5-10-2026.
   - Voegt het product toe zodra er iets anders in de cart ligt, haalt het weg als de cart verder leeg is.
   - Zet de klant de schakelaar uit (of verwijdert de regel op /cart), dan blijft het deze sessie uit.
   - De schakelaar en de verborgen regel staan in snippets/cart-drawer.liquid (data-ll-sp). */
(function () {
  var HANDLE = 'shipping-protection';
  var OPT = 'll_sp_optout';
  var HAD = 'll_sp_had';
  var SECTIONS = 'cart-drawer,cart-counter';
  var origFetch = window.fetch.bind(window);
  var busy = false;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function variantId() {
    var el = document.querySelector('[data-ll-sp]');
    return el ? Number(el.getAttribute('data-variant')) : 0;
  }
  function render(sections) {
    if (!sections) return;
    var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
    if (sections['cart-drawer']) {
      var nb = parse(sections['cart-drawer']).querySelector('#CartDrawer-Body');
      var ob = document.querySelector('#CartDrawer-Body');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
    }
    if (sections['cart-counter']) {
      var nc = parse(sections['cart-counter']).querySelector('#shopify-section-cart-counter');
      var oc = document.querySelector('#shopify-section-cart-counter');
      if (nc && oc) oc.innerHTML = nc.innerHTML;
    }
  }
  function post(url, body) {
    return origFetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function add() {
    var v = variantId();
    if (!v) return Promise.resolve();
    return post('cart/add.js', { items: [{ id: v, quantity: 1 }], sections: SECTIONS })
      .then(function (r) { render(r.sections); });
  }
  function setQty(id, q) {
    return post('cart/change.js', { id: id, quantity: q, sections: SECTIONS })
      .then(function (r) { render(r.sections); });
  }
  function getCart() {
    return origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function sync() {
    if (busy || !variantId()) return;
    busy = true;
    getCart().then(function (cart) {
      var sp = cart.items.filter(function (i) { return i.handle === HANDLE; });
      var others = cart.items.filter(function (i) { return i.handle !== HANDLE; });
      if (!others.length) {
        ss(HAD, null);
        if (sp.length) return setQty(sp[0].key, 0);
        return;
      }
      if (sp.length) {
        ss(HAD, cart.token);
        if (sp[0].quantity > 1) return setQty(sp[0].key, 1);
        return;
      }
      if (ss(OPT) === '1') return;
      // Stond hij in deze cart en is hij weg zonder dat wij het deden? Dan heeft de klant hem verwijderd.
      if (ss(HAD) === cart.token) { ss(OPT, '1'); return; }
      return add().then(function () { ss(HAD, cart.token); });
    }).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ll-sp-toggle]')) return;
    t.disabled = true;
    var done = function () { t.disabled = false; };
    if (t.checked) {
      ss(OPT, null);
      add().then(sync, done);
    } else {
      ss(OPT, '1');
      setQty(String(variantId()), 0).then(done, done);
    }
  });

  // Theme en apps veranderen de cart via fetch; daarna gelijktrekken.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(sync, 350); }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-link]')) setTimeout(sync, 50);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
